module.exports = __webpack_public_path__ + "img/safe-lock.e2d16f63.svg";